import styled from "styled-components";

export const DataValueStatisticsLabelContainer = styled.div<{ width?: number }>`
  width: ${({ width }) => (width ? `${width}px` : 'auto')};
`;

export const DataValueStatisticsContainer = styled.div<{ width?: number }>`
  display: flex;
  align-items: center;
  column-gap: 12px;
`;
